// Port of api/fuel/app/classes/insights/game/tags.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'tags',
    priority: 2,
    enabled: false,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)

        var raw = Util.queryFast(
            'SELECT t.tag_id AS id, t.tag_text AS text, t.tag_colour AS colour, t.tag_fore AS fore, ' +
            't.tag_context AS context, t.family_id AS family_id, tf.family_name AS family_name ' +
            'FROM tag_attach ta ' +
            'JOIN tag t ON ta.tag_id = t.tag_id ' +
            'LEFT JOIN tag_family tf ON t.family_id = tf.family_id ' +
            'WHERE ta.game_id = ' + game_id + ' AND t.user_id = ' + user_id
        )

        var tags = []

        for (var i = 0; i < raw.length; i++) {
            tags.push({
                id: parseInt(raw[i].id, 10),
                text: raw[i].text,
                colour: raw[i].colour,
                fore: raw[i].fore,
                context: parseInt(raw[i].context, 10),
                family_id: parseInt(raw[i].family_id, 10),
                family_name: raw[i].family_name
            })
        }

        return {
            tags: tags
        }

    }
})
